import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { AppSnackbarProps } from "./types";

const AppSnackbar = ({
  open,
  message,
  severity = "success",
  autoHideDuration = 3000,
  anchorOrigin = {
    vertical: "top",
    horizontal: "right",
  },
  onClose,
}: AppSnackbarProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
      onClose={(_, reason) => {
        if (reason === "clickaway") return;
        onClose();
      }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={severity}
        onClose={onClose}
        sx={{
          minWidth: 320,
          borderRadius: 2,
        }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default AppSnackbar;